module.exports = __webpack_public_path__ + "e75700e591464db19698814b2e4933fa.svg";